module.exports = __webpack_public_path__ + "img/logo-hrd@2x.666adda.webp";